var prevTimeId = 0;
var prevUniqueId = 0;
export function uid(prefix) {
    var newUniqueId = Date.now();
    if (newUniqueId === prevTimeId) {
        ++prevUniqueId;
    }
    else {
        prevTimeId = newUniqueId;
        prevUniqueId = 0;
    }
    var uniqueId = "" + String(newUniqueId) + String(prevUniqueId);
    if (prefix) {
        uniqueId = prefix + "_" + uniqueId;
    }
    return uniqueId;
}
//# sourceMappingURL=uid.js.map